import React from 'react';
import { VStack } from '@chakra-ui/react';
import { useAccess } from 'hooks';

import { Sessions, Whitelist } from './components';

const SecurityTab: React.FC = () => {
  const access = useAccess();

  return (
    <VStack w="100%" align="stretch" gap={4} my={{ base: 4, md: 8 }}>
      {access.whiteListCryptoWithdrawalService && <Whitelist />}
      <Sessions />
    </VStack>
  );
};

export default SecurityTab;
